import { Actualizador } from "./Actualizador";
import { InvestigacionesService } from "../../../../servicesBackend/investigaciones.service";
import { InvestigacionDTO } from "@DTOS";
import { DatosActualizarInvestigacion } from "../DatosActualizarInvestigacion";
import { AccionEnum } from "@shared/enums";
import { RespuestasService } from "../../../../../layout/investigaciones/ver-respuestas/respuestas.service";

export class MarcadorActualizador extends Actualizador {
    constructor(private investigacionesService: InvestigacionesService, private respuestasService: RespuestasService) {
        super();
        this.modificarEstado = (state, investigacion, datos) => {
            switch (datos.datosMarcadores!.accion) {
            case AccionEnum.AGREGAR:
                break;
            case AccionEnum.ACTUALIZAR:
                state.marcadoresInvestigacionSeleccionada = state.marcadoresInvestigacionSeleccionada!.map(marcador =>
                    marcador.id === datos.datosMarcadores!.marcador.id ? datos.datosMarcadores!.marcador : marcador
                );
                break;
            }
        };
    }

    async actualizar(investigacion: InvestigacionDTO, datos: DatosActualizarInvestigacion): Promise<InvestigacionDTO> {
        const clonInvestigacion = investigacion.clon();
        switch (datos.datosMarcadores!.accion) {
        case AccionEnum.AGREGAR:
            const marcador = await this.investigacionesService.agregarMarcador(
                clonInvestigacion, datos.datosMarcadores!.marcador.envio, datos.datosMarcadores!.marcador
            );
            this.respuestasService.agregarMarcador(marcador);
            break;
        case AccionEnum.ACTUALIZAR:
            break;
        }
        return clonInvestigacion;
    }

    esActualizador(datos: DatosActualizarInvestigacion): boolean {
        return datos.datosMarcadores != null;
    }

}
